/**
 * TokenStore — lưu access token TRONG BỘ NHỚ (không localStorage/sessionStorage).
 *
 * Vì sao in-memory: localStorage có thể bị đọc bởi mã XSS → lộ token. Giữ token trong
 * closure module-scope khiến mọi script bên thứ ba không truy cập trực tiếp được. Đánh đổi:
 * token mất khi reload tab — bù lại bằng "silent refresh" qua httpOnly refresh cookie
 * (cookie không đọc được từ JS, gửi tự động kèm request tới API cùng site).
 *
 * Backend E1 (auth) chưa hiện thực refresh-cookie → `refresh` để skeleton, app tự quyết
 * khi nào gọi. Khi E1 xong: thay thân `refresh` bằng `POST /v1/auth/refresh` (credentials:'include').
 */
export interface TokenStore {
  /** Token hiện tại trong RAM, hoặc null khi chưa đăng nhập / đã hết hạn. */
  readonly get: () => string | null;
  /** Đặt token sau khi đăng nhập / refresh thành công. */
  readonly set: (token: string) => void;
  /** Xoá token (đăng xuất). */
  readonly clear: () => void;
}

/** Tạo một TokenStore in-memory độc lập (mỗi app một instance). */
export function createTokenStore(): TokenStore {
  let token: string | null = null;
  return {
    get: () => token,
    set: (value: string) => {
      token = value;
    },
    clear: () => {
      token = null;
    },
  };
}
